import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { isNilOrEmptyString } from '@/shared/lib'

import { ExpandableText, Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'usageGuide'>

export const UsageGuide = ({ usageGuide }: Props) => {
  const t = useTranslations('room_detail')

  if (isNilOrEmptyString(usageGuide)) return null

  return (
    <section className="w-full space-y-3">
      <Heading>{t('unit_guide.title')}</Heading>
      <ExpandableText content={usageGuide} className="typo-body2" />
    </section>
  )
}
